const VehicleType = {
    Car: 40,
    Van: 41,
    Bike: 42
}

export default VehicleType;